import axios from 'axios';

export async function getGiftCardPoints(giftcardId) {
  try {
    const { data } = await axios.get(`${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}/api/v2/proxies/giftcard/${giftcardId}`, {
      headers: { appId: process.env.appId },
    });
    return { data };
  } catch (error) {
    return { error };
  }
}
